/* eslint-disable consistent-return */
/* eslint-disable global-require */
import KatalLogger from '@amzn/katal-logger';

const KATAL_LOG_URL = '/seller-forums/logs';

const getLogger = () => {
  if (typeof window !== 'undefined') {
    const { default: KatLogger, Level } = require('@amzn/katal-logger');
    const config: any = {
      url: KATAL_LOG_URL,
      logThreshold: Level.INFO,
      maxLogLineSize: 100000,
      logToConsole: false,
      decodeStackTrace: true,
    };
    const loggerClient = new KatLogger(config);
    loggerClient.addErrorListener();
    loggerClient.addPerformanceListener();
    return loggerClient;
  }
};

const clientLogger: KatalLogger = getLogger();
export default clientLogger;
